package ui.screens.section.wisheslist

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.runtime.snapshotFlow
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import data.repository.FirebaseInvitationRepo
import models.Wish
import ui.composables.PAGE_SIZE
import ui.theme.ColorScheme
import ui.theme.txtColor

@Composable
fun WishesListSection(repo: FirebaseInvitationRepo) {

    val listState = rememberLazyListState()

    var wishes by remember { mutableStateOf<List<Wish>>(emptyList()) }
    var cursor by remember { mutableStateOf<Long?>(null) }
    var isLoading by remember { mutableStateOf(false) }
    var hasMore by remember { mutableStateOf(true) }

    // 🔥 load pertama
    LaunchedEffect(Unit) {
        isLoading = true
        val (data, nextCursor) = repo.loadMoreWishes(PAGE_SIZE, null)
        wishes = data
        cursor = nextCursor
        hasMore = data.isNotEmpty()
        isLoading = false
    }

    // 🔥 detect scroll ke bawah
    LaunchedEffect(listState) {
        snapshotFlow {
            listState.layoutInfo.visibleItemsInfo.lastOrNull()?.index
        }.collect { lastIndex ->
            lastIndex?.let { index ->
                if (
                    index >= (wishes.lastIndex - 2) &&
                    !isLoading &&
                    hasMore
                ) {
                    isLoading = true

                    val (moreData, nextCursor) = repo.loadMoreWishes(
                        PAGE_SIZE,
                        cursor
                    )

                    wishes = (wishes + moreData).distinctBy { it.createdAt }
                    cursor = nextCursor
                    hasMore = moreData.isNotEmpty()

                    isLoading = false
                }
            }
        }
    }

    if (wishes.isEmpty()) return

    Column(
        Modifier
            .padding(24.dp)
            .widthIn(max = 450.dp)
    ) {

        Text(
            text = "Daftar Ucapan:",
            fontWeight = FontWeight.Bold,
            color = txtColor,
            modifier = Modifier.padding(bottom = 8.dp)
        )

        LazyColumn(
            state = listState,
            modifier = Modifier.heightIn(max = 350.dp),
            verticalArrangement = Arrangement.spacedBy(6.dp)
        ) {

            items(
                items = wishes,
                key = { it.name }
            ) { wish ->
                WishItem(wish)
            }

            // 🔥 loading indicator
            if (isLoading) {
                item {
                    Box(
                        Modifier
                            .fillMaxWidth()
                            .padding(12.dp),
                        contentAlignment = Alignment.Center
                    ) {
                        CircularProgressIndicator()
                    }
                }
            }
        }
    }
}

@Composable
fun WishItem(wish: Wish) {
    Column(
        Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(12.dp))
            .background(Color.White)
            .padding(12.dp)
    ) {
        Text(
            text = wish.name,
            style = MaterialTheme.typography.titleSmall.copy(
                fontWeight = FontWeight.Bold
            ),
            color = ColorScheme.primary
        )

        EmojiText(wish.message)
    }
}